module.exports = __webpack_public_path__ + "static/media/ComingSoon.c82ed969.png";